import { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa"; // Import icon từ Font Awesome

const BackToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    show && (
      <button
        id="back-top"
        className={`back-to-top ${show ? "show" : ""}`}
        onClick={scrollToTop}
      >
        <FaArrowUp />
      </button>
    )
  );
};

export default BackToTop;
